export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10064.b7082394.jpg";